import { Product, ProductAddon, ProductDetail, ProductStore } from '../models/interfaces-general';
import { ProductoComplementoApi, ProductoDetalleApi, ProductoListApi } from '../models/api/producto-api';
import { Constante } from '../../constante';

export class ProductoMapper {
    static toCarousel(item: ProductoListApi): Product {
        const images = [item.urlImagen, item.urlImagenHover].filter((url): url is string => !!url);
        return {
            id: item.uuid,
            name: item.nombre,
            images: images.length > 0 ? images : [''],
            originalPrice: item.precioOferta != null ? item.precio : undefined,
            discountPrice: item.precioFinal,
            discountPercentage: item.porcentajeDescuento ?? undefined,
            currency: 'S/',
            url: `${Constante.URL_PRODUCTO}/${item.slug}`
        };
    }

    static toStore(item: ProductoListApi): ProductStore {
        return {
            id: item.uuid,
            title: item.nombre,
            price: item.precioFinal,
            imageUrl: item.urlImagen || '',
            badgeText: item.esNuevo
                ? 'Nuevo'
                : item.porcentajeDescuento
                    ? `-${item.porcentajeDescuento}%`
                    : undefined,
            badgeType: item.esNuevo ? 'new' : item.porcentajeDescuento ? 'discount' : undefined,
            targetUrl: `${Constante.URL_PRODUCTO}/${item.slug}`
        };
    }

    static toDetail(item: ProductoDetalleApi): ProductDetail {
        const images = (item.imagenes ?? [])
            .map((img) => img.urlMedium || img.urlOriginal)
            .filter((url): url is string => !!url);

        return {
            id: item.uuid,
            title: item.nombre,
            price: item.precioFinal,
            images: images.length > 0 ? images : [item.imagenes?.[0]?.urlOriginal || ''],
            sku: item.sku,
            inStock: item.stockDisponible > 0,
            descriptionHtml: item.descripcion ?? undefined,
            specifications: item.especificaciones ?? undefined
        };
    }

    static toAddon(item: ProductoComplementoApi): ProductAddon {
        return {
            id: item.uuid,
            name: item.nombre,
            price: item.precio,
            imageUrl: item.urlImagen || ''
        };
    }
}
